import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { fetchSession, login, logout, type Session } from '@/features/auth/api'
import type { ApiError } from '@/lib/api/client'

export const sessionKey = ['session'] as const

export function useSession() {
  return useQuery<Session, ApiError>({
    queryKey: sessionKey,
    queryFn: fetchSession,
    retry: false,
    staleTime: 5 * 60 * 1000,
  })
}

export function useLogin() {
  const queryClient = useQueryClient()

  return useMutation<unknown, ApiError, { email: string; password: string }>({
    mutationFn: ({ email, password }) => login(email, password),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: sessionKey }),
  })
}

export function useLogout() {
  const queryClient = useQueryClient()

  return useMutation<void, ApiError, void>({
    mutationFn: logout,
    onSuccess: () => queryClient.clear(),
  })
}
